import { Spinner } from '../../ui'
import styles from './AnalysisPage.module.css'

export interface ProcessStep {
  label: string
  detail: string
}

interface ProcessStepsProps {
  steps: ProcessStep[]
}

export function ProcessSteps({ steps }: ProcessStepsProps) {
  return (
    <div className={styles.processSteps} data-scope="process-steps">
      <div className={styles.processHead}><Spinner style={{ width: 18, height: 18 }} /><span>AI广告引擎正在处理</span></div>
      <ol className={styles.processList}>
        {steps.map((step) => (
          <li className={styles.processStep} key={`${step.label}-${step.detail}`}>
            <b>{step.label}</b>
            <span>{step.detail}</span>
          </li>
        ))}
      </ol>
    </div>
  )
}
